const compararStringsSinDiacriticos = (opcion, segundaOpcion) => {
    return opcion.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(segundaOpcion.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
};

export { compararStringsSinDiacriticos };